import { render, staticRenderFns } from "./Oops.vue?vue&type=template&id=348b5e2f&scoped=true"
import script from "./Oops.vue?vue&type=script&lang=js"
export * from "./Oops.vue?vue&type=script&lang=js"
import style0 from "./Oops.vue?vue&type=style&index=0&id=348b5e2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b5e2f",
  null
  
)

export default component.exports